export default "__VITE_ASSET__H1NIz$zM__"